import { render } from "./Scenario.vue?vue&type=template&id=6508a0f3&scoped=true"
import script from "./Scenario.vue?vue&type=script&lang=js"
export * from "./Scenario.vue?vue&type=script&lang=js"

import "./Scenario.vue?vue&type=style&index=0&id=6508a0f3&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\ehaat-ambulance-game\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6508a0f3"]])

export default __exports__